var _Defs, _Use, _Use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, LinearGradient, Stop, Symbol as _Symbol, Path, Use } from "react-native-svg";
function SvgRainy(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "rainy_svg__b",
    x1: 99.45,
    y1: 30.68,
    x2: 232.64,
    y2: 261.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "rainy_svg__a",
    x1: 1381.32,
    y1: -1144.67,
    x2: 1399.47,
    y2: -1097.39,
    gradientTransform: "rotate(-9 8002.567 8233.063)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#0b65ed"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#0a5ad4"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#0950bc"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "rainy_svg__c",
    x1: 1428.42,
    y1: -1084.66,
    x2: 1446.57,
    y2: -1037.37,
    gradientTransform: "rotate(-9 8009.537 8233.037)",
    xlinkHref: "#rainy_svg__a"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#0b65ed"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#0a5ad4"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#0950bc"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "rainy_svg__d",
    x1: 1489.3,
    y1: -1111.57,
    x2: 1507.45,
    y2: -1064.28,
    gradientTransform: "rotate(-9 8016.566 8233.078)",
    xlinkHref: "#rainy_svg__a"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#0b65ed"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#0a5ad4"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#0950bc"
  })), /*#__PURE__*/React.createElement(_Symbol, {
    id: "rainy_svg__e",
    viewBox: "0 0 350 222"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M291 107c-.85 0-1.68.09-2.53.13A83.9 83.9 0 00135.6 42.92 55.91 55.91 0 0051 91a56.56 56.56 0 00.8 9.08A60 60 0 0063 219c1.35 0 2.67-.11 4-.2v.2h224a56 56 0 000-112z",
    stroke: "#959aa2",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    fill: "url(#rainy_svg__b)"
  })), /*#__PURE__*/React.createElement(_Symbol, {
    id: "rainy_svg__f",
    viewBox: "0 0 129 110"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M8.5 56.5a8 8 0 01-8-8v-40a8 8 0 0116 0v40a8 8 0 01-8 8z",
    stroke: "#0a5ad4",
    strokeMiterlimit: 10,
    fill: "url(#rainy_svg__a)"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M64.5 109.5a8 8 0 01-8-8v-40a8 8 0 0116 0v40a8 8 0 01-8 8z",
    stroke: "#0a5ad4",
    strokeMiterlimit: 10,
    fill: "url(#rainy_svg__c)"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M120.5 74.5a8 8 0 01-8-8v-40a8 8 0 0116 0v40a8 8 0 01-8 8z",
    stroke: "#0a5ad4",
    strokeMiterlimit: 10,
    fill: "url(#rainy_svg__d)"
  })))), _Use || (_Use = /*#__PURE__*/React.createElement(Use, {
    width: 350,
    height: 222,
    transform: "translate(81 145)",
    xlinkHref: "#rainy_svg__e"
  })), _Use2 || (_Use2 = /*#__PURE__*/React.createElement(Use, {
    width: 129,
    height: 110,
    transform: "translate(191.5 343.5)",
    xlinkHref: "#rainy_svg__f"
  })));
}
export default SvgRainy;